export default class TextInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      value: props.value || '',
      focused: false
    };
  }

  render() {
    const classes = classNames({
      'show-labelholder': this.state.value,
      'focused': this.state.focused,
    }, 'labelholder')
    return (
      <div className={classes}
           data-label={this.props.placeholder || ''}>
        <input type="email"
               className={`form-control ${this.state.value ? 'has-value': ''}`}
               value={this.state.value || ''}
               onChange={this._input.bind(this)}
               onFocus={() => this.setState({focused: true})}
               onBlur={() => this.setState({focused: false})}
               name={this.props.name}
               placeholder={this.props.placeholder || ''}
               id={this.props.field}/>
        <div className="remover" onClick={this._clear.bind(this)}></div>
      </div>
    );
  }

  _input(e) {
    this.setState({value: e.target.value})
  }

  _clear() {
    this.setState({value: null})
  }
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string
};

